var exports = {
  "nf": "xe564cbfb--b71f8d--link",
  "Kk": "xe564cbfb--b71f8d--icon",
  "RL": "xe564cbfb--b71f8d--icon--additional",
  "Qq": "xe564cbfb--b71f8d--text",
};

module.exports = exports;
